document.addEventListener('click', function (event) {
  var tab = event.target.closest('[data-store-tab]');
  if (!tab) return;

  var root = tab.closest('[data-store-locator]');
  var storeId = tab.getAttribute('data-store-tab');
  if (!root || !storeId) return;

  root.querySelectorAll('[data-store-tab]').forEach(function (item) {
    var isActive = item === tab;
    item.classList.toggle('is-active', isActive);
    item.setAttribute('aria-selected', isActive ? 'true' : 'false');
  });

  root.querySelectorAll('[data-store-panel]').forEach(function (panel) {
    panel.classList.toggle('is-active', panel.getAttribute('data-store-panel') === storeId);
  });
});
